import { Group, Paper, Stack, Text } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';
import { DeliveryDetails as DeliveryDetailsData } from 'types/lcms/courses';
import LoadingText from './LoadingText';
import { labelMapping } from 'constant/course';

interface DeliveryDetailsProps {
  data?: DeliveryDetailsData;
  loading?: boolean;
}

const DeliveryDetails: React.FC<DeliveryDetailsProps> = ({ data, loading }) => {
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineDocumentText />
          <Text c={'dark'} fw={700}>
            Delivery Details
          </Text>
        </Group>
        {loading && <LoadingText />}
        {!loading && data && (
          <>
            {Object.keys(data).map((key, i) => {
              if (key === 'learningObjectives') {
                return (
                  <Stack key={i} gap={0}>
                    <Text c={'dark'} fw={600} fz={14}>
                      {labelMapping[key] || key}
                    </Text>
                    <Paper withBorder px={24} style={{ overflow: 'auto' }}>
                      <div
                        dangerouslySetInnerHTML={{ __html: String(data[key as keyof typeof data]) }}
                      />
                    </Paper>
                  </Stack>
                );
              }
              return (
                <Stack gap={4} key={i}>
                  <Text c={'dark'} fw={600} fz={14}>
                    {labelMapping[key] || key}
                  </Text>

                  <Text fz={14} c={'secondary'}>
                    {data[key as keyof typeof data] || '-'}
                  </Text>
                </Stack>
              );
            })}
          </>
        )}
      </Stack>
    </Card>
  );
};

export default DeliveryDetails;
